"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NeutralColorPure = exports.NeutralColorMediumContrast = exports.NeutralColorLowContrast = exports.NeutralColorHighContrast = exports.NeutralColorButton = exports.FontFamilyPrimary = exports.FeedbackColorSuccessPure = exports.FeedbackColorSuccessMediumContrast = exports.FeedbackColorSuccessLowContrast = exports.FeedbackColorSuccessHighContrast = exports.FeedbackColorErrorPure = exports.FeedbackColorErrorMediumContrast = exports.FeedbackColorErrorLowContrast = exports.FeedbackColorErrorHighContrast = exports.FeedbackColorButton = exports.FeedbackColorAlertPure = exports.FeedbackColorAlertMediumContrast = exports.FeedbackColorAlertLowContrast = exports.FeedbackColorAlertHighContrast = exports.ColorSecondaryPure = exports.ColorSecondaryMedium = exports.ColorSecondaryLight = exports.ColorSecondaryDark = exports.ColorPrimaryPure = exports.ColorPrimaryMedium = exports.ColorPrimaryLight = exports.ColorPrimaryDark = void 0;
/**
 * Do not edit directly
 * Generated on Fri, 11 Apr 2025 12:21:57 GMT
 */

var FeedbackColorSuccessPure = "#0CF26C";
exports.FeedbackColorSuccessPure = FeedbackColorSuccessPure;
var FeedbackColorSuccessHighContrast = "#BBFAD5";
exports.FeedbackColorSuccessHighContrast = FeedbackColorSuccessHighContrast;
var FeedbackColorSuccessMediumContrast = "#0CF26C";
exports.FeedbackColorSuccessMediumContrast = FeedbackColorSuccessMediumContrast;
var FeedbackColorSuccessLowContrast = "#048C3D";
exports.FeedbackColorSuccessLowContrast = FeedbackColorSuccessLowContrast;
var FeedbackColorErrorPure = "#F53131";
exports.FeedbackColorErrorPure = FeedbackColorErrorPure;
var FeedbackColorErrorHighContrast = "#FAAFAF";
exports.FeedbackColorErrorHighContrast = FeedbackColorErrorHighContrast;
var FeedbackColorErrorMediumContrast = "#FA7D7D";
exports.FeedbackColorErrorMediumContrast = FeedbackColorErrorMediumContrast;
var FeedbackColorErrorLowContrast = "#8F0012";
exports.FeedbackColorErrorLowContrast = FeedbackColorErrorLowContrast;
var FeedbackColorAlertPure = "#F2B20C";
exports.FeedbackColorAlertPure = FeedbackColorAlertPure;
var FeedbackColorAlertHighContrast = "#F5D993";
exports.FeedbackColorAlertHighContrast = FeedbackColorAlertHighContrast;
var FeedbackColorAlertMediumContrast = "#F2B20C";
exports.FeedbackColorAlertMediumContrast = FeedbackColorAlertMediumContrast;
var FeedbackColorAlertLowContrast = "#A67A08";
exports.FeedbackColorAlertLowContrast = FeedbackColorAlertLowContrast;
var FeedbackColorButton = "#FFFFFF";
exports.FeedbackColorButton = FeedbackColorButton;
var NeutralColorPure = "#FFFFFF";
exports.NeutralColorPure = NeutralColorPure;
var NeutralColorHighContrast = "#D9D9D9";
exports.NeutralColorHighContrast = NeutralColorHighContrast;
var NeutralColorMediumContrast = "#A6A6A6";
exports.NeutralColorMediumContrast = NeutralColorMediumContrast;
var NeutralColorLowContrast = "#666666";
exports.NeutralColorLowContrast = NeutralColorLowContrast;
var NeutralColorButton = "#000000";
exports.NeutralColorButton = NeutralColorButton;
var ColorPrimaryPure = "#000000";
exports.ColorPrimaryPure = ColorPrimaryPure;
var ColorPrimaryLight = "#8c8c8c";
exports.ColorPrimaryLight = ColorPrimaryLight;
var ColorPrimaryMedium = "#383838";
exports.ColorPrimaryMedium = ColorPrimaryMedium;
var ColorPrimaryDark = "#151515";
exports.ColorPrimaryDark = ColorPrimaryDark;
var ColorSecondaryPure = "#ffff00";
exports.ColorSecondaryPure = ColorSecondaryPure;
var ColorSecondaryLight = "#ffffe4";
exports.ColorSecondaryLight = ColorSecondaryLight;
var ColorSecondaryMedium = "#ffff99";
exports.ColorSecondaryMedium = ColorSecondaryMedium;
var ColorSecondaryDark = "#6b6b03";
exports.ColorSecondaryDark = ColorSecondaryDark;
var FontFamilyPrimary = "'IBM Plex Sans', sans-serif";
exports.FontFamilyPrimary = FontFamilyPrimary;